import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=112e1d94&scoped=true"
import script from "./SidebarContent.vue?vue&type=script&lang=ts"
export * from "./SidebarContent.vue?vue&type=script&lang=ts"
import style0 from "./SidebarContent.vue?vue&type=style&index=0&id=112e1d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e1d94",
  null
  
)

export default component.exports